import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionQuotationPage_OneQuotation_QueryDocument = graphql(`
  query MissionQuotationPage_OneQuotation_Query($id: Id!) {
    findOneQuotation(id: $id) {
      _id
      code
      codingConfig {
        kind
        strategyId
        ... on CodingConfigManual {
          code
        }
        ...CodeCmp_CodingConfig_Fragment
      }
      title
      typeId
      kind
      updatedAt
      contentUpdatedAt
      createdAt
      updaterId
      creatorId
      printing {
        pdfPrints {
          _id
          increment
          file {
            _id
            uri
          }
          isTmp
          createdAt
          creatorId
          automaticMemo
          internalMemo
          memo
        }
        pdfPrintsIncrement
        printSettings {
          addHeaders
          addFooters
          printStyleId
        }
      }
      templateId
      virtualRoot {
        _id
        template {
          _id
          type
        }
        contentOriginId
        isVirtual
        hasPagebreakBefore
        hasPagebreakAfter
        title
        content
        orientation
        paperFormat
        isInsertionPoint
        customLayouts {
          _id
          sectionId
          orientation
          paperFormat
          hasPagebreakAfter
          hasPagebreakBefore
        }
        displayCondition {
          mode
          resolverId
          value
        }

        subSections {
          _id
          template {
            _id
            type
          }
          contentOriginId
          isVirtual
          hasPagebreakBefore
          hasPagebreakAfter
          title
          content
          orientation
          paperFormat
          isInsertionPoint
          customLayouts {
            _id
            sectionId
            orientation
            paperFormat
            hasPagebreakAfter
            hasPagebreakBefore
          }
          displayCondition {
            mode
            resolverId
            value
          }

          subSections {
            _id
            template {
              _id
              type
            }
            contentOriginId
            isVirtual
            hasPagebreakBefore
            hasPagebreakAfter
            title
            content
            orientation
            paperFormat
            isInsertionPoint
            customLayouts {
              _id
              sectionId
              orientation
              paperFormat
              hasPagebreakAfter
              hasPagebreakBefore
            }
            displayCondition {
              mode
              resolverId
              value
            }

            subSections {
              _id
              template {
                _id
                type
              }
              contentOriginId
              isVirtual
              hasPagebreakBefore
              hasPagebreakAfter
              title
              content
              orientation
              paperFormat
              isInsertionPoint
              customLayouts {
                _id
                sectionId
                orientation
                paperFormat
                hasPagebreakAfter
                hasPagebreakBefore
              }
              displayCondition {
                mode
                resolverId
                value
              }

              subSections {
                _id
                template {
                  _id
                  type
                }
                contentOriginId
                isVirtual
                hasPagebreakBefore
                hasPagebreakAfter
                title
                content
                orientation
                paperFormat
                isInsertionPoint
                customLayouts {
                  _id
                  sectionId
                  orientation
                  paperFormat
                  hasPagebreakAfter
                  hasPagebreakBefore
                }
                displayCondition {
                  mode
                  resolverId
                  value
                }

                subSections {
                  _id
                  template {
                    _id
                    type
                  }
                  contentOriginId
                  isVirtual
                  hasPagebreakBefore
                  hasPagebreakAfter
                  title
                  content
                  orientation
                  paperFormat
                  isInsertionPoint
                  customLayouts {
                    _id
                    sectionId
                    orientation
                    paperFormat
                    hasPagebreakAfter
                    hasPagebreakBefore
                  }
                  displayCondition {
                    mode
                    resolverId
                    value
                  }

                  subSections {
                    _id
                    template {
                      _id
                      type
                    }
                    contentOriginId
                    isVirtual
                    hasPagebreakBefore
                    hasPagebreakAfter
                    title
                    content
                    orientation
                    paperFormat
                    isInsertionPoint
                    customLayouts {
                      _id
                      sectionId
                      orientation
                      paperFormat
                      hasPagebreakAfter
                      hasPagebreakBefore
                    }
                    displayCondition {
                      mode
                      resolverId
                      value
                    }

                    subSections {
                      _id
                      template {
                        _id
                        type
                      }
                      contentOriginId
                      isVirtual
                      hasPagebreakBefore
                      hasPagebreakAfter
                      title
                      content
                      orientation
                      paperFormat
                      isInsertionPoint
                      customLayouts {
                        _id
                        sectionId
                        orientation
                        paperFormat
                        hasPagebreakAfter
                        hasPagebreakBefore
                      }
                      displayCondition {
                        mode
                        resolverId
                        value
                      }

                      subSections {
                        _id
                        template {
                          _id
                          type
                        }
                        contentOriginId
                        isVirtual
                        hasPagebreakBefore
                        hasPagebreakAfter
                        title
                        content
                        orientation
                        paperFormat
                        isInsertionPoint
                        customLayouts {
                          _id
                          sectionId
                          orientation
                          paperFormat
                          hasPagebreakAfter
                          hasPagebreakBefore
                        }
                        displayCondition {
                          mode
                          resolverId
                          value
                        }

                        subSections {
                          _id
                          template {
                            _id
                            type
                          }
                          contentOriginId
                          isVirtual
                          hasPagebreakBefore
                          hasPagebreakAfter
                          title
                          content
                          orientation
                          paperFormat
                          isInsertionPoint
                          customLayouts {
                            _id
                            sectionId
                            orientation
                            paperFormat
                            hasPagebreakAfter
                            hasPagebreakBefore
                          }
                          displayCondition {
                            mode
                            resolverId
                            value
                          }

                          subSections {
                            _id
                            template {
                              _id
                              type
                            }
                            contentOriginId
                            isVirtual
                            hasPagebreakBefore
                            hasPagebreakAfter
                            title
                            content
                            orientation
                            paperFormat
                            isInsertionPoint
                            customLayouts {
                              _id
                              sectionId
                              orientation
                              paperFormat
                              hasPagebreakAfter
                              hasPagebreakBefore
                            }
                            displayCondition {
                              mode
                              resolverId
                              value
                            }

                            subSections {
                              _id
                              template {
                                _id
                                type
                              }
                              contentOriginId
                              isVirtual
                              hasPagebreakBefore
                              hasPagebreakAfter
                              title
                              content
                              orientation
                              paperFormat
                              isInsertionPoint
                              customLayouts {
                                _id
                                sectionId
                                orientation
                                paperFormat
                                hasPagebreakAfter
                                hasPagebreakBefore
                              }
                              displayCondition {
                                mode
                                resolverId
                                value
                              }

                              subSections {
                                _id
                                template {
                                  _id
                                  type
                                }
                                contentOriginId
                                isVirtual
                                hasPagebreakBefore
                                hasPagebreakAfter
                                title
                                content
                                orientation
                                paperFormat
                                isInsertionPoint
                                customLayouts {
                                  _id
                                  sectionId
                                  orientation
                                  paperFormat
                                  hasPagebreakAfter
                                  hasPagebreakBefore
                                }
                                displayCondition {
                                  mode
                                  resolverId
                                  value
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      createdAt
      creatorId
      updatedAt
      contentUpdatedAt
      updaterId
    }
  }
`);

export type MissionQuotationPage_OneQuotation = ResultOf<
  typeof MissionQuotationPage_OneQuotation_QueryDocument
>['findOneQuotation'];

export const useFindOneQuotationQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    MissionQuotationPage_OneQuotation_QueryDocument,
    { id },
    { enabled: !!id },
  );
